<template>
  <component
    :is="orientation === 'vertical' ? 'li' : 'b-media'"
    :class="[
      'bg-white shadow rounded position-relative',
      orientation === 'vertical' ? 'card-vertical' : 'outline-error p-1'
    ]"
    :tag="orientation === 'vertical' ? undefined : 'li'"
    :no-body="orientation !== 'vertical'"
  >
    <!-- LAYOUT HORIZONTAL -->
    <template v-if="orientation === 'horizontal'">
      <b-media-aside class="mt-auto mb-auto">
        <b-img
          v-if="!!getItemPrice.flagImg"
          :src="getItemPrice.flagImg"
          width="75"
          height="75"
          class="position-absolute"
          style="top: -7px; left: 55px; object-fit: contain; z-index: 2"
        />

        <div class="d-flex align-items-center">
          <b-button
            v-if="!isSuggestion"
            class="cart-item-button"
            style="border: 0px !important"
            variant="outline-danger"
            @click="onRemoveItem"
          >
            <b-icon
              icon="trash"
              font-scale="1.5"
              text
            />
          </b-button>

          <div class="horizontal-image-container">
            <b-img
              width="75"
              height="75"
              :alt="cartItem.skuProduct.name"
              :src="cartItem.skuProduct.imageSquare || logoImg"
              class="rounded"
              style="object-fit: contain; max-width: 100%; max-height: 100%"
            />
          </div>
        </div>
      </b-media-aside>

      <b-media-body>
        <b-row
          class="d-flex justify-content-between"
          style="min-height: 75px"
        >
          <b-col
            md="8"
            class="d-flex flex-column"
          >
            <h5
              v-if="!isFeatured"
              class="mt-0 mb-1"
            >
              {{ cartItem.skuProduct.name }}
            </h5>
            <h5
              v-else
              class="mt-0 mb-1 font-weight-bold"
              style="margin-top: 22px !important;"
            >
              Deseja adicionar <b>{{ cartItem.skuProduct.name }}</b> por mais <span class="text-success">{{ getItemPrice.price | currency(null, 2) }}</span>?
            </h5>

            <div
              v-if="getKitItems.length > 0"
              class="mb-2"
            >
              <div
                v-for="(kitItem, index) in getKitItems"
                :key="`cartSidebar_${index}`"
                style="font-size: 12px; gap: 5px"
              >
                <div class="d-flex">
                  <p class="mb-0 font-weight-bolder w-100 text-right">
                    {{ kitItem.quantity }}x
                  </p>
                  <p
                    class="mb-0"
                    style="min-width: 280px"
                  >
                    {{ kitItem.skuProduct.name }}
                  </p>
                </div>

                {{ void (tempKitItemValidation = getItemWithError(kitItem)) }}
                <atm-cart-item-validation-message
                  v-if="tempKitItemValidation"
                  class="cart-validation-message ml-3"
                  is-item-kit
                  :cart-item-validation-result="tempKitItemValidation"
                />
              </div>
            </div>

            <!-- price -->
            <div
              v-if="!isFeatured"
              class="mt-auto d-flex justify-content-between"
            >
              <div class="d-flex font-weight-bold">
                <p
                  v-if="!isSuggestion"
                  class="mb-0"
                  style="margin-right: 5px"
                >
                  {{ cartItem.quantity }}x
                </p>
                <div class="d-flex gap-1 align-items-start">
                  <b-badge
                    v-if="isSpendAndGetReward"
                    variant="success"
                    class="align-middle"
                    style="font-size: 0.85rem; padding: 4px 10px"
                  >
                    {{ $t('Brinde') }}
                  </b-badge>
                  <template v-else>
                    <p
                      class="mb-0 product-price"
                      style="margin-right: 5px"
                    >
                      {{ getItemPrice.price | currency(null, 2) }}
                    </p>
                    <span
                      v-if="getItemPrice.hasOldPrice"
                      class="mb-0 product-price-canceled small"
                    >
                      {{ getItemPrice.oldPrice | currency(null, 2) }}
                    </span>
                  </template>
                </div>
              </div>
              <div>
                <p
                  v-if="!isSuggestion && !isSpendAndGetReward"
                  class="mb-0 font-weight-bold"
                >
                  {{ getItemPrice.netValue | currency(null, 2) }}
                </p>
              </div>
            </div>
          </b-col>
          <!-- /price -->

          <b-col
            md="4 "
            class="d-flex justify-content-end align-items-center"
            style="margin-top: 14px"
          >
            <template v-if="isSuggestion">
              <item-quantity-input
                :id="`suggestion_item_${getCartItemId}`"
                :product="cartItem.skuProduct"
                mode="add"
                :busy="busy"
                :cart-item="cartItem"
                @add-suggestion="onAddSuggestion"
              />
            </template>
            <template v-else>
              <item-quantity-input
                :id="`cart_item_${getCartItemId}`"
                :product="cartItem.skuProduct"
                :cart-item="cartItem"
              />
            </template>
          </b-col>
        </b-row>

        <b-row v-if="cartItem && !cartItem.isKit && cartItemError && cartItemError.exceedStock">
          <b-col md="12">
            <atm-cart-item-validation-message
              class="cart-validation-message"
              :cart-item-validation-result="cartItemError"
            />
          </b-col>
        </b-row>
      </b-media-body>
    </template>

    <!-- LAYOUT VERTICAL -->
    <div
      v-else
      class="d-flex flex-column p-1"
    >
      <!-- Flag de promoção/desconto (fora do container de imagem) -->
      <b-img
        v-if="!!getItemPrice.flagImg"
        :src="getItemPrice.flagImg"
        width="75"
        height="75"
        class="position-absolute"
        style="top: -15px; left: 5px; object-fit: contain; z-index: 2"
      />

      <!-- Imagem no topo -->
      <div class="vertical-image-container mb-2">
        <b-img
          :width="imageWidth"
          :height="imageHeight"
          :alt="cartItem.skuProduct.name"
          :src="cartItem.skuProduct.imageSquare || logoImg"
          class="rounded"
          style="object-fit: contain; width: 100%; height: 100%"
        />
      </div>

      <!-- Nome do produto -->
      <h6 class="mb-2 font-weight-bold text-center text-truncate-2">
        {{ cartItem.skuProduct.name }}
      </h6>

      <!-- Preço -->
      <div class="text-center mb-3">
        <div class="d-flex justify-content-center gap-1 align-items-center">
          <b-badge
            v-if="isSpendAndGetReward"
            variant="success"
            class="align-middle"
            style="font-size: 0.95rem; padding: 4px 10px"
          >
            {{ $t('Brinde') }}
          </b-badge>
          <template v-else>
            <p class="mb-0 product-price font-weight-bold text-success">
              {{ getItemPrice.price | currency(null, 2) }}
            </p>
            <span
              v-if="getItemPrice.hasOldPrice"
              class="mb-0 product-price-canceled small"
            >
              {{ getItemPrice.oldPrice | currency(null, 2) }}
            </span>
          </template>
        </div>
        <p
          v-if="!isSuggestion && !isSpendAndGetReward"
          class="mb-0 small text-muted"
        >
          Total: {{ getItemPrice.netValue | currency(null, 2) }}
        </p>
      </div>

      <!-- Botão de adicionar ou input de quantidade -->
      <div class="mt-auto">
        <template v-if="isSuggestion">
          <item-quantity-input
            :id="`suggestion_item_vertical_${getCartItemId}`"
            :product="cartItem.skuProduct"
            :mode="orientation === 'vertical' ? 'add-suggestion' : 'add'"
            :busy="busy"
            :cart-item="cartItem"
            @add-suggestion="onAddSuggestion"
          />
        </template>
        <template v-else>
          <item-quantity-input
            :id="`cart_item_vertical_${getCartItemId}`"
            :product="cartItem.skuProduct"
            :cart-item="cartItem"
          />
        </template>
      </div>
    </div>
  </component>
</template>

<script>
import { BButton, BIcon, BCol, BImg, BMedia, BMediaAside, BMediaBody, BRow, BBadge } from 'bootstrap-vue'
import logoImg from '@/assets/images/logo/echope_small.png'
import promotionImg from '@/assets/images/on_promotion.png'
import tieredPriceImg from '@/assets/images/leve-mais-pague-menos.png'
import { mapActions, mapGetters } from 'vuex'
import { payBoxRewards, payBoxUtils } from '@/mixins'
import ItemQuantityInput from '../input/ItemQuantityInput.vue'
import AtmCartItemValidationMessage from './AtmCartItemValidationMessage.vue'

export default {
  components: {
    BMedia,
    BImg,
    BRow,
    BCol,
    BButton,
    BIcon,
    BBadge,
    ItemQuantityInput,
    BMediaAside,
    BMediaBody,
    AtmCartItemValidationMessage,
  },

  mixins: [payBoxRewards],

  props: {
    /** item da venda em pay-box */
    cartItem: {
      type: Object,
      required: true,
    },
    /** indica se é um item de sugestão (modo leitura) */
    isSuggestion: {
      type: Boolean,
      default: false,
    },
    /** indica se é um item em destaque (modo leitura) */
    isFeatured: {
      type: Boolean,
      default: false,
    },
    /** orientação do card: 'horizontal' (default) ou 'vertical' */
    orientation: {
      type: String,
      default: 'horizontal',
      validator: value => ['horizontal', 'vertical'].includes(value),
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logoImg,
      promotionImg,
      tieredPriceImg,
      imageWidth: 75,
      imageHeight: 75,
    }
  },

  computed: {
    ...mapGetters('pages/pdv/atm', {
      stGetDictCartItemsWithErrors: 'getDictCartItemsWithErrors',
      stIsCartWithErrors: 'isCartWithErrors',
    }),

    cartItemError() {
      return this.getItemWithError(this.cartItem)
    },

    getCartItemId() {
      return this.cartItem.localId || this.cartItem.id
    },
    getItemPrice() {
      const { priceInfo, type } = this.cartItem.priceRuleSelected

      const resultItemPrice = {
        netValue: priceInfo.localNetValue,
        hasOldPrice: priceInfo.hasOldPrice,
        oldPrice: priceInfo.oldPrice,
        price: priceInfo.price,
      }

      if (type === payBoxUtils.priceRuleTypes.SPEND_AND_GET_REWARD || this.cartItem?.isReward) {
        // Brinde: não exibe flag/tag de promoção. O badge "Brinde" é renderizado
        // pela própria UI em substituição ao bloco de preço (não tem flagImg).
        return {
          ...resultItemPrice,
          isReward: true,
        }
      }

      if (type === payBoxUtils.priceRuleTypes.PROMOTION) {
        return {
          ...resultItemPrice,
          flagImg: this.promotionImg,
        }
      }

      if (type === payBoxUtils.priceRuleTypes.TIERED_PRICE) {
        return {
          ...resultItemPrice,
          flagImg: this.tieredPriceImg,
        }
      }

      return resultItemPrice
    },

    /**
     * Indica que o item é um brinde de promoção `SpendAndGet`. A UI mostra
     * um badge dedicado e oculta os controles de quantidade
     * (apenas o botão de remover fica acessível).
     */
    isSpendAndGetReward() {
      if (this.cartItem?.isReward) return true
      const type = this.cartItem?.priceRuleSelected?.type
      return type === payBoxUtils.priceRuleTypes.SPEND_AND_GET_REWARD
    },

    getKitItems() {
      return this.cartItem.kitItems || []
    },
  },

  methods: {
    ...mapActions('pages/pdv/atm', { stRemoveItemFromAtm: 'removeItemFromAtm' }),

    getItemWithError(saleItem) {
      return this.stGetDictCartItemsWithErrors[saleItem.id || saleItem.localId]
    },

    async onRemoveItem() {
      const confirmed = await this.confirm({
        title: this.$t('Deseja remover o produto do carrinho?'),
        text: ' ',
      })
      if (!confirmed) {
        return
      }

      await this.stRemoveItemFromAtm(this.cartItem)

      await this.mxReloadPayBoxRewardApplied()
    },

    /**
     * Manipula o evento de adicionar sugestão vindo do ItemQuantityInput
     * @param {Object} suggestionData - Dados da sugestão (quantity, skuId, ean)
     */
    onAddSuggestion(suggestionData) {
      // Emitir o evento com os dados completos para o componente pai
      this.$emit('add-suggestion', {
        ...suggestionData,
        priceTableId: this.cartItem.priceTableId,
        unitValue: this.getItemPrice.price,
        inputMethod: 'ATM',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.outline-error:has(.cart-validation-message) {
  outline: 1px solid var(--danger);
}

.cart-item-button {
  height: 37px;
  width: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

// Container para imagem horizontal
.horizontal-image-container {
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-left: 10px;
  border-radius: 6px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

// Layout Vertical
.card-vertical {
  display: flex;
  flex-direction: column;
  min-height: 280px;
  min-width: 150px;
  max-width: 180px;
  flex-shrink: 0;
  position: relative;

  .vertical-image-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    overflow: hidden;
  }

  .text-truncate-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 2.4em;
  }

  .product-price {
    font-size: 1.1rem;
  }

  .product-price-canceled {
    text-decoration: line-through;
    color: #999;
  }
}
</style>
